module.exports = __webpack_public_path__ + "static/media/journal-whills.fca4aa72.svg";